







































































import { Prop, Component, Mixins } from "vue-property-decorator";
import InputMixin from "../private/InputMixin";

@Component({
    directives: {
        focus: {
            inserted: function (el, binding) {
                if (binding.value) {
                    el.focus();
                }
            },
        },
    },
})
export default class AbcCheckbox extends Mixins(InputMixin) {
    @Prop() value!: boolean | undefined;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isFocused!: boolean;
    @Prop() label!: string;
    @Prop({ default: null }) info!: string | null;
    @Prop({ type: Boolean }) labelLeft!: boolean;
    @Prop({ type: Boolean }) isList!: boolean;
    @Prop({ type: Boolean }) hasMiddleState!: boolean;

    private haveFocus = false;
    private haveHover = false;

    private get currentVal() {
        return this.value;
    }
    private set currentVal(val: boolean | undefined) {
        this.runRules(val);
        this.$emit("input", val);
    }

    private toggleDummyCheckbox() {
        if (this.currentVal || this.currentVal === undefined) {
            this.currentVal = false;
        } else {
            this.currentVal = true;
        }
        this.$emit("change", this.currentVal);
    }

    private focusChanged(on: boolean) {
        this.haveFocus = on;
        if (!on) {
            this.runRules(this.value);
        }
    }

    get inputClass() {
        return {
            "is-list": this.isList,
            "cursor-pointer": !this.isDisabled,

            "border-secondary-300 dark:border-secondary-dark-200":
                !this.haveHover && !this.haveFocus && !this.haveErrors,
            "border-secondary-400 dark:border-secondary-dark-300":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !this.haveErrors,

            "border-danger-400 dark:border-danger-dark-400 errored": !!this.haveErrors,
            "border-danger-500 dark:border-danger-dark-500":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !!this.haveErrors,

            "abc-checkbox-focused": this.haveFocus && !this.haveErrors,
            "abc-checkbox-focused-error": this.haveFocus && !!this.haveErrors,

            "bg-bg-100 dark:bg-bg-dark-100": !this.isDisabled,
            "bg-bg-500 dark:bg-bg-dark-500 text-label-primary dark:text-label-primary-dark effect-on-disabled":
                this.isDisabled,

            checked: this.hasMiddleState && this.currentVal === true,
            "not-checked": this.hasMiddleState && this.currentVal === false,
            undefined:
                this.hasMiddleState &&
                this.currentVal !== true &&
                this.currentVal !== false &&
                this.currentVal !== 1 &&
                this.currentVal !== 0,
        };
    }

    get bgClass() {
        return {
            "effect-on-disabled": this.isDisabled,
        };
    }

    get labelClass() {
        return {
            "effect-on-hover": !this.isDisabled,
            "text-danger-500 dark:text-danger-dark-500": !!this.haveErrors,
            "text-label-primary dark:text-label-primary-dark": this.isDisabled,
        };
    }
}
